var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedhalfcircle3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7677",
    "data-name": "Group 7677",
    xmlns: "http://www.w3.org/2000/svg",
    width: 193.851,
    height: 267.246,
    viewBox: "0 0 193.851 267.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_18",
    "data-name": "Subtraction 18",
    d: "M0,267.246H0V0A138.261,138.261,0,0,1,25.046,4.843a137.171,137.171,0,0,1,23.176,9.124A137.208,137.208,0,0,1,69.076,26.924,136.846,136.846,0,0,1,87.154,43.27,135.37,135.37,0,0,1,102,62.56a133.38,133.38,0,0,1,11.167,21.786,132.075,132.075,0,0,1,7.033,23.837,133.362,133.362,0,0,1,2.445,25.441,133.368,133.368,0,0,1-2.445,25.441,132.057,132.057,0,0,1-7.033,23.836A133.365,133.365,0,0,1,102,204.686a135.41,135.41,0,0,1-14.849,19.289,136.915,136.915,0,0,1-18.078,16.346,137.209,137.209,0,0,1-20.854,12.957A137.231,137.231,0,0,1,25.046,262.4,138.3,138.3,0,0,1,0,267.246Z",
    transform: "translate(122.648 267.246) rotate(180)",
    fill: "#e3334a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_19",
    "data-name": "Subtraction 19",
    d: "M99.628,0H0V108.544A111.177,111.177,0,0,0,70.8,73.4,109.973,109.973,0,0,0,82.858,57.727a108.337,108.337,0,0,0,9.071-17.7A107.081,107.081,0,0,0,99.628,0Z",
    transform: "translate(94.223 37.461)",
    fill: "#fdb913"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedhalfcircle3);
export default __webpack_public_path__ + "static/media/redhalfcircle3.64ad02dd946f64bbb56cff59cc02668e.svg";
export { ForwardRef as ReactComponent };